import { createAsyncThunk } from "@reduxjs/toolkit";
import localhost from "apis/localhost";
import { showErrorModal } from "slices/app/actions/error";
import { addToJobQueue, removeFromJobQueue } from "slices/app/appSlice";

const ALL_LANGUAGES = { name: "All", code: "all" };

export const fetchLanguages = createAsyncThunk(
  "watchwords/languages",
  async (_, { dispatch }) => {
    dispatch(addToJobQueue("fetchLanguages"));

    try {
      const rsp = await localhost.get("watchwords/languages");
      const languages = rsp?.data || [];
      return [ALL_LANGUAGES, ...languages];
    } catch (err) {
      dispatch(showErrorModal(err, "There was a problem fetching languages"));

      return [ALL_LANGUAGES];
    } finally {
      dispatch(removeFromJobQueue("fetchLanguages"));
    }
  }
);
